import React, { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const WishlistContext = createContext(null);
const STORAGE_KEY = "welljio_wishlist_v1";

function read() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter((x) => typeof x === "string") : [];
  } catch {
    return [];
  }
}

export function WishlistProvider({ children }) {
  const [ids, setIds] = useState(read);

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(ids)); } catch { /* ignore */ }
  }, [ids]);

  const has = (id) => ids.includes(id);

  const toggle = (id, productName) => {
    setIds((prev) => {
      if (prev.includes(id)) {
        toast(`Removed ${productName || "item"} from wishlist`);
        return prev.filter((x) => x !== id);
      }
      toast.success(`Saved ${productName || "item"} to wishlist`);
      return [...prev, id];
    });
  };

  const remove = (id) => setIds((prev) => prev.filter((x) => x !== id));
  const clear = () => setIds([]);

  return (
    <WishlistContext.Provider value={{ ids, has, toggle, remove, clear, count: ids.length }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
